import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballThirdBase = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.69841 6.23765L7.48976 7.43544L6.91019 7.93001L7.41249 8.54049L7.18838 9.77691L6.18379 10.6347H3.69549L3 9.79237L4.0896 8.86505L4.55326 9.42917H5.70468L5.92105 9.24371L6.00605 8.76459L5.82832 8.54822H4.36779L4.56098 7.45862H5.93651L6.15288 7.28088L6.24561 6.7554L6.10651 6.5854H5.1251L4.5378 7.08769L3.75731 6.14492L4.66144 5.37988H6.99519L7.69841 6.23765ZM13.0042 6.26856L12.8033 7.44316L12.2392 7.91455L12.7569 8.54822L12.5483 9.746L11.5051 10.6347H7.79579L8.72311 5.37988H12.2778L13.0042 6.26856ZM11.1805 7.45862L11.451 7.23452L11.536 6.7554L11.3891 6.5854H9.89771L9.75088 7.45862H11.1805ZM11.25 9.22825L11.3273 8.80323L11.1187 8.54822H9.55769L9.40314 9.42917H11.0105L11.25 9.22825Z"
      fill="white"
    />
  </svg>
);
